import { DOC_MIME_TYPES, XLS_MIME_TYPES, PPT_MIME_TYPES, PDF_MIME_TYPES, JPG_MIME_TYPES, PNG_MIME_TYPES, GIF_MIME_TYPES } from './constants';
/**
 * Similar documents (for example MS Word) can have many mime types
 * Check if given mime type matches ANY mime type of the group
 *
 * @param {String[]} types - array of mime types to check
 * @returns {function}
 */

function matchMimeTypes(types) {
  /**
   * @param {String} mimeType
   */
  return function (mimeType) {
    return !!mimeType && types.includes(mimeType);
  };
}

export var matchDOCMimeType = matchMimeTypes(DOC_MIME_TYPES);
export var matchXLSMimeType = matchMimeTypes(XLS_MIME_TYPES);
export var matchPPTMimeType = matchMimeTypes(PPT_MIME_TYPES);
export var matchPDFMimeType = matchMimeTypes(PDF_MIME_TYPES);
export var matchJPGMimeType = matchMimeTypes(JPG_MIME_TYPES);
export var matchPNGMimeType = matchMimeTypes(PNG_MIME_TYPES);
export var matchGIFMimeType = matchMimeTypes(GIF_MIME_TYPES);